import * as React from 'react'
import styled from 'styled-components'
import { NextSeo } from 'next-seo'

import { RichText } from '@bob/rich-text'
import { styles as S } from '@bob/design-system'
import * as ds from '@bob/design-system'
import * as url from '@bob/url'

import { SITE_NAME, SITE_URL } from '@bob/config'

export type TemplateProps = {
  data: {
    title: string
    slug: string
    content: any
  }
}

export function Template({ data }: TemplateProps): React.ReactElement {
  const pageUrl = url.aboutPage({ slug: data.slug, title: data.title })

  return (
    <>
      <NextSeo
        title={`${SITE_NAME} | ${data.title}`}
        description={`${data.title} de ${SITE_NAME}`}
        openGraph={{
          title: `${SITE_NAME} | ${data.title}`,
          description: `${data.title} de ${SITE_NAME}`,
          url: SITE_URL + pageUrl.path,
          images: [
            {
              alt: `${data.title} de Bien ou Bien`,
              url: SITE_URL + '/assets/images/bob_og_image.png',
            },
          ],
        }}
      />
      <ds.Container>
        <ds.BreadCrumbs crumbs={pageUrl.crumbs} />
      </ds.Container>
      <SmallContainer>
        <Wrapper>
          <S.heading.Title1>{data.title}</S.heading.Title1>
          <S.heading.Title2>{data.title}</S.heading.Title2>
        </Wrapper>
        <RichText document={data.content.json} links={data.content.links} />
        {/*<Cta>
                    <div>{"Vous n'avez pas trouvé de réponse ?"}</div>
                    <Button>Contactez nous !</Button>
                </Cta>*/}
      </SmallContainer>
    </>
  )
}

export const SmallContainer = styled(ds.Container)`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  max-width: 842px;

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-bottom: 80px;
  }
`

export const Wrapper = styled.div`
  margin: 0px auto;
  margin-bottom: 40px;
  margin-top: 20px;
  max-width: 80%;
  text-align: center;

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-bottom: 80px;
    margin-top: 60px;
    max-width: 100%;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    /* media query desktop, hide Title1 */
    ${ds.styles.heading.Title1} {
      display: none;
    }
  }
  @media not screen and (${ds.breakpoint.TABLET}) {
    /* media query mobile, hide Title2 */
    ${ds.styles.heading.Title2} {
      display: none;
    }
  }
`
